const MAX_NON_SCIENTIFIC_NOTATION_VALUE = 1e9;
const MIN_NON_SCIENTIFIC_NOTATION_VALUE = 1e-3;
const SCIENTIFIC_NOTATION_DIGITS_AFTER_DECIMAL = 2;
const NON_SCIENTIFIC_NOTATION_DIGITS_AFTER_DECIMAL = 3;

/**
 * Format a number into the standard pretty number format for charts.
 *
 * If `useFullNumber` is false, format the number so that:
 *   1. If it's 0, return 0
 *   2. If its absolute value is >= 1e9 or < 1e-3, use scientific notation with 2 digits after the decimal.
 *   3. Otherwise, include 3 digits after the decimal.
 *
 * If `useFullNumber` is true, format the number to localized string without any rounding or scientific notation.
 */
export default function prettyChartNumber(number: number, useFullNumber: boolean = false): string {
  if (useFullNumber) {
    // `undefined` locale uses the default locale.
    // Set `maximumFractionDigits` to 20 since it needs to be a number between 0 and 20. This should be close to
    // rarely rounding in practice.
    return number.toLocaleString(undefined, {maximumFractionDigits: 20});
  }

  return Math.abs(number) >= MAX_NON_SCIENTIFIC_NOTATION_VALUE ||
    (Math.abs(number) < MIN_NON_SCIENTIFIC_NOTATION_VALUE && Math.abs(number) > 0)
    ? number.toLocaleString(undefined, {
        notation: 'scientific',
        maximumFractionDigits: SCIENTIFIC_NOTATION_DIGITS_AFTER_DECIMAL,
      })
    : number.toLocaleString(undefined, {
        maximumFractionDigits: NON_SCIENTIFIC_NOTATION_DIGITS_AFTER_DECIMAL,
      });
}
